<template>
  <div class="qir-lead-form__wrapper">
    <h2 class="qir-lead-form__title secondary-title">
      {{ formTitle }}
    </h2>

    <a-button
      :to="atlasQirRegistrationUrl"
      :loading="isButtonLoading"
      class="qir-lead-form__submit"
    >
      Buy Latest Report
    </a-button>
  </div>
</template>

<script>
import AButton from 'shared/AButton/index.vue'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'
import { PROP_TYPES, propValidator } from '@fmpedia/validators'

export default {
  name: 'QirLeadForm',
  mixins: [hydrationHelpers],
  components: {
    AButton
  },
  props: {
    reportId: propValidator([PROP_TYPES.STRING], false, ''),
    reportYearQuarter: propValidator([PROP_TYPES.OBJECT], false, null),
    isReportLoadInProgress: propValidator([PROP_TYPES.BOOLEAN]),
    isReportDataFailedToLoad: propValidator([PROP_TYPES.BOOLEAN])
  },
  data() {
    return {
      inProgress: false
    }
  },
  computed: {
    atlasQirRegistrationUrl() {
      return this.$env.ATLAS_QIR_REGISTRATION_URL
    },
    isButtonLoading() {
      return this.inProgress || this.isReportLoadInProgress
    },
    formTitle() {
      return `Get the ${this.reportYearQuarterFormatted}Industry Insights`
    },
    reportYearQuarterFormatted() {
      if (!this.reportYearQuarter) {
        return ''
      }

      const { Year, Quarter } = this.reportYearQuarter

      return `Q${Quarter}/${Year} `
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/local/mixins/grid';

$title-color: #f5f5f6;

.qir-lead-form__wrapper {
  background: $c--gray-dark !important;

  $padding: (
    $above-desktop-xl: 47px,
    $mobile: 16px
  );

  @include setStyleByBreakpoint('padding', $padding);

  .qir-lead-form__title {
    color: $title-color;
    margin-bottom: 12px;

    $max-width: (
      $desktop-md: 465px,
      $tablet: unset
    );

    @include setStyleByBreakpoint('max-width', $max-width);
  }

  .qir-lead-form__submit {
    margin-top: 8px;
    width: 100%;
  }
}
</style>
